import { SET_ACTION_BUFFER, SET_ACTION_BUFFER_SUCCESS, ERASE_ACTION_BUFFER, ERASE_ACTION_BUFFER_SUCCESS } from './constants';

/**
 *
 * @param obj
 * @returns {{obj: *, type: string}}
 */
const putActionActionBuffer = (obj) => ({
    type: SET_ACTION_BUFFER,
    obj
});
/**
 *
 * @returns {{type: string}}
 */
const eraseActionBuffer = () => ({
    type: ERASE_ACTION_BUFFER
});
/**
 *
 * @returns {{type: string}}
 */
const eraseActionBufferSuccess = () => ({
    type: ERASE_ACTION_BUFFER_SUCCESS
});
/*

 */
const  putActionBufferSuccess = (obj) => ({
    type: SET_ACTION_BUFFER_SUCCESS,
    obj
});

export {
    putActionActionBuffer,
    putActionBufferSuccess ,
    eraseActionBufferSuccess,
    eraseActionBuffer
};